module.exports = __webpack_public_path__ + "ab0070e81c7a18d2a192face33a7fc8a.woff2";